<template>
  <div class="elasticsearchResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="domainName"
          :placeholder="$t('RAM.common.DomainName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="accountNameSearchKey"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticsearch:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableElasticsearchResource from "../elasticsearch/TableElasticsearchResource";
var tableElasticsearchResource = TableElasticsearchResource;
export default {
  name: "ElasticsearchResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountNameSearchKey: "",
      domainName: "",
      accountNameSearchID: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("domainName", this.domainName);
      eventBus.$emit("accountNameSearchID", this.accountNameSearchKey);
      tableElasticsearchResource.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.elasticsearchResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticsearch/ElasticsearchResourceSearch.vue